import { MapID } from "./defines/enums"
import { Engine } from "./engine"

window.addEventListener("DOMContentLoaded", () => {
  const messages = window.document.getElementById("messages")
  const game = window.document.getElementById("game")
  const stats = window.document.getElementById("stats")
  if (messages && game && stats) {
    window.engine = new Engine(messages, game, stats, MapID.Portals)

    const ticker = document.getElementById("ticker")
    const canvas = document.querySelector("canvas")

    if (ticker && canvas) {
      ticker.setAttribute("style", "width: " + String(canvas.width) + "px")
    }
  }
})
